import { useState } from "react";
import { Mail, Flame } from "lucide-react";
import { Link } from "react-router-dom";
import xLogo from "@/assets/x-logo.png";
import discordLogo from "@/assets/discord-logo.svg";
// Logo is now text-based KBETS branding
import HowItWorksDialog from "./HowItWorksDialog";

const Footer = () => {
  const [showHowItWorks, setShowHowItWorks] = useState(false);

  const handleGetStarted = () => {
    // Just close the dialog
    setShowHowItWorks(false);
  };

  return (
    <>
      <footer className="border-t border-border bg-card/30">
        <div className="container mx-auto px-4 py-8">
          {/* Main Content */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
            {/* Brand */}
            <div className="space-y-3">
              <Link to="/" className="inline-block group">
                <div className="flex items-center gap-2">
                  <Flame className="h-5 w-5 text-primary transition-transform duration-300 group-hover:scale-110" />
                  <span className="text-xl font-bold text-foreground tracking-tight">
                    KB<span className="text-primary">E</span>TS
                  </span>
                </div>
              </Link>
              <p className="text-sm text-muted-foreground">
                Bet on esports matches
              </p>
            </div>

            {/* Navigation Links */}
            <div>
              <h3 className="font-semibold mb-3 text-sm">Resources</h3>
              <ul className="space-y-2 text-sm text-muted-foreground">
                <li>
                  <Link to="/docs" className="hover:text-primary transition-colors">
                    Documentation
                  </Link>
                </li>
              </ul>
            </div>

            {/* Contact */}
            <div>
              <h3 className="font-semibold mb-3 text-sm">Connect</h3>
              <div className="space-y-2">
                <div className="flex gap-3">
                  <a 
                    href="https://x.com/KBOOMGG" 
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-9 h-9 rounded-lg bg-secondary hover:bg-primary transition-all hover:scale-105 flex items-center justify-center group"
                    aria-label="Follow us on X"
                  >
                    <img src={xLogo} alt="X" className="w-4 h-4 group-hover:brightness-0 group-hover:invert transition-all" />
                  </a>
                  <a 
                    href="https://discord.gg/Hn9WCVA8" 
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-9 h-9 rounded-lg bg-secondary hover:bg-primary transition-all hover:scale-105 flex items-center justify-center group"
                    aria-label="Join our Discord"
                  >
                    <img src={discordLogo} alt="Discord" className="w-5 h-5 group-hover:brightness-0 group-hover:invert transition-all" />
                  </a>
                  <a 
                    href="mailto:contact@kboom.gg" 
                    className="w-9 h-9 rounded-lg bg-secondary hover:bg-primary hover:text-primary-foreground transition-all hover:scale-105 flex items-center justify-center"
                    aria-label="Email us"
                  >
                    <Mail className="w-4 h-4" />
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Bottom */}
          <div className="pt-6 border-t border-border flex flex-col md:flex-row justify-center items-center gap-2 md:gap-4 text-center">
            <p className="text-xs text-muted-foreground">
              © 2025 KBETS. All rights reserved.
            </p>
            <span className="hidden md:inline text-muted-foreground text-xs">•</span>
            <div className="flex gap-4 text-xs text-muted-foreground">
              <a href="/privacy" className="hover:text-primary transition-colors">Privacy Policy</a>
              <a href="/terms" className="hover:text-primary transition-colors">Terms of Service</a>
            </div>
          </div>
        </div>
      </footer>
      <HowItWorksDialog 
        open={showHowItWorks} 
        onOpenChange={setShowHowItWorks}
        onGetStarted={handleGetStarted}
      />
    </>
  );
};

export default Footer;